import { render, staticRenderFns } from "./Setname.vue?vue&type=template&id=46700b12&scoped=true"
import script from "./Setname.vue?vue&type=script&lang=js"
export * from "./Setname.vue?vue&type=script&lang=js"
import style0 from "./Setname.vue?vue&type=style&index=0&id=46700b12&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_17bc9983cdb7459b16429e97d92f86dc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46700b12",
  null
  
)

export default component.exports